import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { DropzoneFile } from '../../models/dropzone';
import { Header, Icon } from 'semantic-ui-react';

interface Props {
  setFiles: (files: DropzoneFile[]) => void;
}

const PhotoWidgetDropzone: React.FC<Props> = ({ setFiles }) => {
  const dzStyles = {
    border: 'dashed 3px #eee',
    borderColor: '#eee',
    borderRadius: '5px',
    paddingTop: '30px',
    textAlign: 'center' as const,
    height: 200,
  };

  const dzActive = {
    borderColor: 'green',
  };

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      const updatedFiles: DropzoneFile[] = acceptedFiles.map((file: File) => ({
        ...file,
        preview: URL.createObjectURL(file),
      }));

      setFiles(updatedFiles);
    },
    [setFiles],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const currentStyle = isDragActive ? { ...dzStyles, ...dzActive } : dzStyles;

  return (
    <div {...getRootProps()} style={currentStyle}>
      <input {...getInputProps()} />
      <Icon name="upload" size="huge" />
      <Header content="Drop image here" />
    </div>
  );
};

export { PhotoWidgetDropzone };
